import ColumnAvatar from '../components/Redesing/column-avatar';
import PersonIcon from '@mui/icons-material/Person';
import { Stack, Typography } from '@mui/material';
import { SeverityPill } from '../components/Redesing/severity-pill';
import IconButtonMenu from '../components/Redesing/icon-button-menu';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export const adminColumns = (onEdit, onRemove) => [
  {
    id: 'admin',
    label: 'Admin',
    searchable: true,
    showToolTip: true,
    maxWidth: '350px',
    // displayed as one cell; the hidden columns below keep the CSV export
    // shape (First Name, Last Name, Email) unchanged
    shouldNotExport: true,
    format: (cell) => (
      <ColumnAvatar
        avatar={<PersonIcon />}
        firstRow={
          <Typography color="text.pramary" variant="body1">
            {`${cell?.firstName || ''} ${cell?.lastName || ''}`.trim()}
          </Typography>
        }
        secondRow={
          <Typography color="text.secondary" variant="body2">
            <SeverityPill color={'info'}>{cell?.email || ''}</SeverityPill>
          </Typography>
        }
      />
    ),
  },
  {
    id: 'firstName',
    label: 'First Name',
    hidden: true,
  },
  {
    id: 'lastName',
    label: 'Last Name',
    hidden: true,
  },
  {
    id: 'email',
    label: 'Email',
    hidden: true,
  },
  {
    id: 'actions',
    label: 'Actions',
    notSortable: true,
    align: 'center',
    shouldNotExport: true,
    format: (row) => (
      <Stack justifyContent={'center'} alignItems={'center'}>
        <IconButtonMenu
          buttons={[
            {
              label: '',
              startIcon: <EditIcon />,
              onClick: (e) => {
                e.stopPropagation();
                onEdit(row);
              },
            },
            ...(onRemove
              ? [
                  {
                    label: '',
                    startIcon: <DeleteIcon />,
                    onClick: (e) => {
                      e.stopPropagation();
                      onRemove(row);
                    },
                  },
                ]
              : []),
          ]}
        />
      </Stack>
    ),
  },
];
